import { defineMessages } from 'react-intl';

export default function initCourses() {
  defineMessages({
    course_appetizer: {
      id: 'course.Appetizer',
      defaultMessage: 'Appetizer',
    },
    course_breakfast: {
      id: 'course.Breakfast',
      defaultMessage: 'Breakfast',
    },
    course_cake: {
      id: 'course.Cake',
      defaultMessage: 'Cake and Baking',
    },
    course_dessert: {
      id: 'course.Dessert',
      defaultMessage: 'Dessert',
    },
    course_drink: {
      id: 'course.Drink',
      defaultMessage: 'Drinks and Cocktails',
    },
    course_entry: {
      id: 'course.Entry',
      defaultMessage: 'Entry',
    },
    course_main: {
      id: 'course.Main',
      defaultMessage: 'Main Course',
    },
    course_salad: {
      id: 'course.Salad',
      defaultMessage: 'Salad',
    },
    course_side: {
      id: 'course.Side Dish',
      defaultMessage: 'Side Dish',
    },
    course_snacks: {
      id: 'course.Snack',
      defaultMessage: 'Snack',
    },
    course_soup: {
      id: 'course.Soup',
      defaultMessage: 'Soup',
    },
  });
}
